__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-17-1771315841-stable-dev/";